// Use relative imports to avoid dependency cycles
import { isAllUpperCase } from '../isAllCase';
import { isRomanNumeral } from '../isRomanNumeral';
import { ALWAYS_CAPITALIZE_WORDS } from './constants';

const shouldMakeUpperCase = (word: string): boolean => isRomanNumeral(word) || isAllUpperCase(word) || ALWAYS_CAPITALIZE_WORDS.includes(word.toUpperCase());

export default shouldMakeUpperCase;
